import { Component } from "react";
import Modal, { Styles } from "react-modal";

import { Text } from "@chakra-ui/react";
require("./dialogMessage.css");
const modalStyles = {
  content: {
    height: "25%",
    margin: "auto",
    position: "absolute",
    top: "0%",
    left: "0%",
    right: "0%",
    bottom: "0%",
    background: "white", // Set the background color of the modal
    borderRadius: "8px", // Add rounded corners if desired
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Add a subtle shadow
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.5)", // Set the background color and opacity of the overlay
  },
};


interface IMessageProps {
  closeCallback: () => void;
  icon?: JSX.Element;
  title: JSX.Element | string;
  messageText: string;
  buttons: JSX.Element;
}
export default class DialogMessage extends Component<IMessageProps, any> {
  constructor(props: IMessageProps) {
    super(props);
    this.state = {
      modalIsOpen: true,
    };
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    return (
      <div>
        <Modal
          className={"widthResponsive"}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          style={modalStyles as Styles}
        >
          <div className="d-flex flex-column justify-content-between h-100">
            <div>
              <Text
                fontSize="xl"
                fontWeight={"bold"}
                color={"blue.700"}
                textTransform={"uppercase"}
                mb={4}
                className="text-center"
              >
                {this.props.title}
              </Text>
              <div className={"messageTextContainer"}>
                {this.props.messageText}
              </div>
            </div>

            <div className={"button-Container d-flex justify-content-around"}>
              {this.props.buttons}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
